import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Target = (props: SvgProps) => (
  <Svg width={29} height={24} viewBox="0 0 29 24" fill="none" {...props}>
    <g filter="url(#filter0_n_11314_41216)">
      <path
        d="M27.7834 5.71841C27.7834 5.71841 28.2952 5.37683 28.0303 4.96999C27.7918 4.6038 27.3134 4.3998 26.4393 4.69017C26.4191 4.73965 26.3697 4.8409 26.2625 4.88575L26.0275 4.98731L27.7831 5.71823L27.7834 5.71841Z"
        fill="#90A3F6"
      />
      <path
        d="M24.6606 5.70908C24.6606 5.70908 26.7329 6.17212 27.6248 5.79478C28.5168 5.41743 27.6206 4.21739 26.0276 4.98753L24.6604 5.70912L24.6606 5.70908Z"
        fill="url(#paint0_linear_11314_41216)"
      />
      <g filter="url(#filter1_i_11314_41216)">
        <path
          d="M26.3418 1.84671C26.3418 1.84671 26.9058 1.6002 27.0949 2.04713C27.2839 2.49406 27.1538 3.06432 26.1807 3.70378L25.9613 3.69829L26.3344 1.85144L26.3418 1.84671Z"
          fill="#90A3F6"
        />
      </g>
      <g filter="url(#filter2_i_11314_41216)">
        <path
          d="M24.5989 4.42829C24.5989 4.42829 25.3732 2.45119 26.1848 1.92233C26.9962 1.39352 27.4904 2.80761 25.9614 3.69806L24.5989 4.42829Z"
          fill="url(#paint1_linear_11314_41216)"
        />
      </g>
      <path
        d="M11.5727 24C17.9641 24 23.1454 18.8185 23.1454 12.4268C23.1454 6.03507 17.9641 0.853577 11.5727 0.853577C5.18128 0.853577 0 6.03507 0 12.4268C0 18.8185 5.18128 24 11.5727 24Z"
        fill="url(#paint2_radial_11314_41216)"
      />
      <path
        d="M12.8027 23.1464C19.1941 23.1464 24.3754 17.9649 24.3754 11.5732C24.3754 5.18149 19.1941 0 12.8027 0C6.41126 0 1.22998 5.18149 1.22998 11.5732C1.22998 17.9649 6.41126 23.1464 12.8027 23.1464Z"
        fill="url(#paint3_radial_11314_41216)"
      />
      <path
        d="M13.6729 20.6281C18.9 20.6281 23.1373 16.3905 23.1373 11.1632C23.1373 5.93597 18.9 1.69843 13.6729 1.69843C8.44586 1.69843 4.2085 5.93597 4.2085 11.1632C4.2085 16.3905 8.44586 20.6281 13.6729 20.6281Z"
        fill="url(#paint4_linear_11314_41216)"
      />
      <path
        d="M14.323 17.2725C17.866 17.2725 20.7382 14.4001 20.7382 10.8569C20.7382 7.31374 17.866 4.44141 14.323 4.44141C10.7799 4.44141 7.90771 7.31374 7.90771 10.8569C7.90771 14.4001 10.7799 17.2725 14.323 17.2725Z"
        fill="url(#paint5_radial_11314_41216)"
      />
      <path
        d="M15.1718 12.8514C16.5943 12.8514 17.7474 11.6982 17.7474 10.2757C17.7474 8.85328 16.5943 7.70013 15.1718 7.70013C13.7493 7.70013 12.5962 8.85328 12.5962 10.2757C12.5962 11.6982 13.7493 12.8514 15.1718 12.8514Z"
        fill="url(#paint6_linear_11314_41216)"
      />
      <path
        d="M15.3282 8.99134C14.9624 9.1749 14.8148 9.62018 14.9983 9.9859C15.1819 10.3516 15.6272 10.4993 15.9929 10.3157L15.6605 9.65353L15.3282 8.99134ZM15.6605 9.65353L15.9929 10.3157L25.9438 5.32115L25.6114 4.65896L25.279 3.99677L15.3282 8.99134L15.6605 9.65353Z"
        fill="url(#paint7_linear_11314_41216)"
      />
      <path
        d="M23.9301 6.18093C23.5668 6.38404 23.1024 6.16979 23.0388 5.75849C23.037 5.74735 23.0356 5.73613 23.0343 5.72491C22.9946 5.36241 23.1446 5.21597 23.5416 5.00526L25.8981 3.71955L26.3373 4.90194L23.9301 6.18114L23.9301 6.18093Z"
        fill="url(#paint8_linear_11314_41216)"
      />
      <path
        d="M23.357 5.77796L25.6767 4.5588C25.6767 4.5588 25.665 4.27284 24.6735 4.67778C23.682 5.08272 23.357 5.77796 23.357 5.77796Z"
        fill="#102892"
      />
      <g filter="url(#filter3_ii_11314_41216)">
        <path
          d="M26.2735 4.92416C26.5404 4.85618 26.6869 4.52663 26.6007 4.18808C26.5145 3.84952 26.2282 3.63018 25.9613 3.69815C25.6944 3.76612 25.5479 4.09568 25.6341 4.43423C25.7204 4.77278 26.0066 4.99213 26.2735 4.92416Z"
          fill="#274AE2"
        />
      </g>
      <path
        d="M23.3384 5.78443C23.3384 5.78443 25.3753 4.18107 25.6768 4.55861C25.6768 4.55861 25.5989 4.37668 25.6094 4.24651C25.6094 4.24651 24.9414 3.9955 23.2796 5.59355L23.3384 5.78443Z"
        fill="#7D94FC"
      />
    </g>
    <defs>
      <filter
        id="filter0_n_11314_41216"
        x="0"
        y="0"
        width="28.1064"
        height="23.9999"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="13.496683120727539 13.496683120727539"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="2609"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(255, 235, 128, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_11314_41216">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_i_11314_41216"
        x="25.7807"
        y="1.72466"
        width="1.38774"
        height="1.97914"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.180713" dy="-0.0542139" />
        <feGaussianBlur stdDeviation="0.187038" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.960784 0 0 0 0 0.980392 0 0 0 0 0.85098 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11314_41216"
        />
      </filter>
      <filter
        id="filter2_i_11314_41216"
        x="24.4541"
        y="1.80719"
        width="2.49955"
        height="2.74759"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.14457" dy="0.126499" />
        <feGaussianBlur stdDeviation="0.15451" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.960784 0 0 0 0 0.980392 0 0 0 0 0.85098 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11314_41216"
        />
      </filter>
      <filter
        id="filter3_ii_11314_41216"
        x="25.3202"
        y="3.39665"
        width="1.59439"
        height="1.81094"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.289141" dy="0.271069" />
        <feGaussianBlur stdDeviation="0.202398" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.960784 0 0 0 0 0.980392 0 0 0 0 0.85098 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11314_41216"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.289141" dy="-0.289141" />
        <feGaussianBlur stdDeviation="0.208723" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_11314_41216"
          result="effect2_innerShadow_11314_41216"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11314_41216"
        x1="27.3162"
        y1="4.65319"
        x2="27.2366"
        y2="6.0128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#102892" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11314_41216"
        x1="26.4335"
        y1="1.81723"
        x2="25.7079"
        y2="3.96845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#102892" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_11314_41216"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.3717 7.80185) rotate(144.96) scale(27.6138 27.6127)"
      >
        <stop stopColor="#F5FAD9" />
        <stop offset="0.714721" stopColor="#EBD870" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_11314_41216"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.6017 6.94828) rotate(144.96) scale(27.6138 27.6127)"
      >
        <stop stopColor="#F5FAD9" />
        <stop offset="1" stopColor="#FFEB80" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_11314_41216"
        x1="20.2175"
        y1="5.13695"
        x2="5.97547"
        y2="17.5179"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF448F" />
        <stop offset="1" stopColor="#D20053" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_11314_41216"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.4281 6.89236) rotate(138.999) scale(12.9471 12.9466)"
      >
        <stop stopColor="#F5FAD9" />
        <stop offset="1" stopColor="#FFEB80" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_11314_41216"
        x1="16.9528"
        y1="8.63584"
        x2="13.0772"
        y2="12.0052"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF448F" />
        <stop offset="1" stopColor="#D20053" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_11314_41216"
        x1="27.296"
        y1="3.21079"
        x2="14.5321"
        y2="10.2331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#15297C" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_11314_41216"
        x1="26.5268"
        y1="4.1811"
        x2="23.1255"
        y2="6.01347"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#617CF0" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Target;
